import CustomerSupport from './CustomerSupport'

const TicketTool = () => {
  return (
    <div>
      <CustomerSupport />
    </div>
  )
}

export default TicketTool
